<template>
    <div>
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <h3 class="mb-0">
                {{ data.type }} <span v-if="data.item_year != null">(Tahun {{ data.item_year }})</span>
                <b-badge class="ml-2" :variant="parseStatus(data.status, 0)">{{ parseStatus(data.status, 1) }}</b-badge>
            </h3>
            {{ data.kind }} - {{ data.brand }}<br />
            {{ data.status == 55 ? "Request hilang" : "Approval" }} oleh <strong>{{ data.approved_by }}</strong> pada {{
            $helper.parseDate(data.approved_at) }}, {{ $helper.parseHourMinute(data.approved_at) }}<br />
            <div v-if="data.noteLost != null">Keterangan hilang: {{ data.noteLost }}</div>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>No. Faktur PGI</strong><br />
                    {{ data.no_faktur_pgi }}
                </b-col>
                <b-col md="4">
                    <strong>IMEI/SN</strong><br />
                    {{ data.imei_sn }}
                </b-col>
                <b-col md="4">
                    <strong>Password</strong><br />
                    <div style="max-width: 250px; word-wrap: break-word;">
                        {{ data.password || "-- Tidak ada password --" }}
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>Grade</strong><br />
                    {{ data.grade }}
                </b-col>
                <b-col md="4">
                    <strong>Spek</strong><br />
                    {{ data.spec }}
                </b-col>
                <b-col md="4">
                    <strong>Kelengkapan</strong><br />
                    {{ data.is_batangan == true ? "Batangan" : "Lengkap" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>Gudang</strong><br />
                    {{ data.warehouse || "-" }}
                </b-col>
                <b-col md="4">
                    <strong>Kloter Pengiriman</strong><br />
                    {{ $helper.parseDate(data.created) }}
                </b-col>
                <b-col md="4">
                    <strong>Deskripsi</strong><br />
                    {{ data.description || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col md="4">
                    <strong>Catatan Barang</strong><br />
                    {{ data.note || "-" }}
                </b-col>
                 <b-col md="4">
                    <strong>No. Faktur Original</strong><br />
                    {{ data.no_faktur_original || "-" }}
                </b-col>
            </b-row>
            <div class="mt-3">
                <strong>ADJUSTMENT HARGA</strong><br />
                Harga Dasar Sekarang: <strong>Rp. {{ $helper.formatThousand(data.type_price) }}</strong><br />
                Harga Dasar (Saat Approval): <strong>Rp. {{ $helper.formatThousand(data.base_price) }}</strong>
            </div>
            <b-table-simple class="mt-2" bordered responsive>
                <b-thead>
                    <b-tr>
                        <b-th>Penyesuaian / Adjustment</b-th>
                        <b-th>Nominal</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>Grade</b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_grade >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_grade) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_grade) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Spec</b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_spec >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_spec) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_spec) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Batangan</b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_batangan >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_batangan) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_batangan) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Kerusakan</b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_kerusakan >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_kerusakan) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_kerusakan) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>
                            Lainnya
                            <div class="small text-muted">
                                {{ data.adj_other_note || "" }}
                            </div>
                        </b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_other >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_other) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_other) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>Segment</b-td>
                        <b-td class="text-right">
                            <div v-if="data.adj_segment >= 0">
                                Rp. {{ $helper.formatThousand(data.adj_segment) }}
                            </div>
                            <div v-else class="text-danger">
                                Rp. {{ $helper.formatThousand(data.adj_segment) }}
                            </div>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td>
                            <strong>Harga Akhir</strong>
                        </b-td>
                        <b-td class="text-right">
                            <!-- <div class="font-weight-bold">Rp. {{ $helper.formatThousand(data.final_price) }}</div> -->
                            <!-- <div class="font-weight-bold">Rp. {{ $helper.formatThousand(data.final_price_after_adj) }}</div> -->
                            <div class="font-weight-bold">Rp. {{ $helper.formatThousand(data.final_price_after_segment)
                                }}</div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-row class="mt-3">
                <b-col md="6">
                    <div class="font-weight-bold">Aksesoris yang Tidak Ada</div>
                    {{ data.missing_accessories || "-" }}
                    <div class="font-weight-bold mt-3">Aksesoris yang Tidak Ori</div>
                    {{ data.not_ori_accessories || "-" }}
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="data.sales_timeline.length != 0">
                <b-col md="12">
                    <strong>Timeline Penjualan dan Retur</strong><br />
                    <ul>
                        <li v-for="(item, index) in data.sales_timeline" v-bind:key="index">
                            <div v-if="item.type == 1">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - PENJUALAN
                                dengan No. Faktur <strong>{{ item.no_faktur }} ({{ item.customer }})</strong> sebesar
                                Rp. {{ $helper.formatThousand(item.total) }}.
                            </div>
                            <div v-else-if="item.type == 2">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - RETUR dengan
                                No. Faktur <strong>{{ item.no_faktur }}</strong> dengan alasan: <strong>{{ item.reason }}</strong>
                            </div>
                            <div v-else-if="item.type == 4">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - INVOICE VOID dengan
                                No. Faktur <strong>{{ item.no_faktur }}</strong>
                            </div>
                            <div v-else-if="item.type == 5">
                                {{ $helper.parseDate(item.at) }}, {{ $helper.parseHourMinute(item.at) }} - RETUR MARKETPLACE dengan
                                No. Faktur <strong>{{ item.no_faktur }}</strong> dengan alasan: <strong>{{ item.reason }}</strong>
                            </div>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <b-row class="mt-3" v-if="data.inventory_pgi_timeline.length != 0">
                <b-col md="12">
                    <strong>Timeline Inventaris</strong><br />
                    <ul>
                        <li v-for="(item, index) in data.inventory_pgi_timeline" :key="index">
                            {{ $helper.parseDate(item.created_at) }}, {{  $helper.parseHourMinute(item.created_at) }} - 
                            Inventaris <strong>{{ parseSendbackStatus(item.action, 1) }}</strong>
                            dengan No. Faktur <strong>{{ item.no_faktur	}}</strong>.
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <div v-if="isEditAllowed()" class="mt-4 text-right">
                <!-- <router-link :to="'/inventory/edit/' + id" class="ml-2">
                    <b-button variant="warning">
                        <i class="fa fa-pencil mr-2" />Edit
                    </b-button>
                </router-link> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isFetching: false,
            isSubmitting: false,

            data: {
                sales_timeline: []
            },

        }
    },
    props: {
        id: { type: Number, required: true }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.$axios.get(`inventory/${this.id}`).then(res => {

                this.initStatus = 1
                this.data = res.data.data

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.initStatus = -1
                })

        },

        isEditAllowed() {
            return this.$helper.isAllowed(this.$helper.PERM_EDIT_INVENTORY) && [2, 4].includes(this.data.status) // READY dan RETUR saja
        },

        parseStatus(status, index) {
            switch (status) {
                case 2: return ["dark", "READY"][index]
                case 3: return ["success", "TERJUAL"][index]
                case 4: return ["warning", "RETUR"][index]
                case 5: return ["danger", "HILANG"][index]
                case 6: return ["primary", "KIRIM BALIK PGI"][index]
                case 7: return ["light", "DRAFT"][index]
                case 55: return ["dark", "REQUEST HILANG"][index]
                case 8: return ["dark", "REQUEST RESET"][index]
                case 9: return ["primary", "REQUEST MOVE"][index]
                case 10: return ["primary", "INVENTARIS"][index]
                case 66: return ["primary", "REQUEST KIRIM BALIK PGI"][index]
                case 11: return ["primary", "REQUEST INVENTARIS"][index]
                default: return ["light", "-"][index]
            }
        },

    parseSendbackStatus(status, index) {
        switch (status) {
            case 10:
                return ["primary", "REQUEST"][index]
            case 11:
                return ["danger", "DITOLAK"][index]
            case 12:
                return ["success", "RETUR"][index]
            case 13: 
                return ['primary', "KIRIM INVENTARIS"][index]
            default:
                return ["light", "-"][index]
        }
    },

    },
    created() {
        this.init()
    }
}
</script>

<style></style>
